<div class="SDeskSidePanel-GreyBackground"></div>

<app-blade-right  *ngIf="!isLoading" size="blade-large">
  <div class="p-10 p-b-0">
    <i (click)="this.close()" class="fas fa-times fa-2x float-end divLink"></i>
    <h3>{{this.loadedId ? 'Edit' : 'Create'}} Change Advisory Board</h3>
  </div>
  <hr>
  <div class="container p-0">

    <div class="row">
      <div class="col-sm-3 formHeader alignMiddle p-10">
        Name <span class="text-danger">*</span>
      </div>
      <div class="col-sm p-10">
        <input [(ngModel)]="loadedData.Name" type="text" class="form-control" id="Name" placeholder="Name" autocomplete="off">

      </div>
    </div>

    <div class="row">
      <div class="col-sm-3 formHeader alignMiddle p-10">
        Description
      </div>
      <div class="col-sm p-10">
        <input [(ngModel)]="loadedData.Description" type="text" class="form-control" id="Description" placeholder="Description" autocomplete="off">

      </div>
    </div>
    <hr>
    <h4>CAB Members <i (click)="openUserSearchModal()" class="fas fa-plus m-l-5 divLink"></i></h4>
    <div class="row">
      <ul class="list-group">
        <li class="list-group-item" *ngFor="let user of loadedData.CabMembers; let i = index">
          {{ user.Name }}
          <i class="far fa-trash-alt float-end m-r-20 divLink" (click)="removeCabMember(i)" aria-hidden="true"></i>
        </li>
      </ul>
    </div>

    <div class="m-t-20">
      <div (click)="save()" class="btn btn-primary">Save</div>
      <div (click)="close()" class="btn btn-cancel">Cancel</div>
    </div>

  </div>
</app-blade-right>
